import React from 'react';

import Committee from './Committee';

function CommitteePage() {
    return ( 
        <>
            <Committee />
        </>
     );
}

export default CommitteePage;